import { useLanguageFromPath } from "plos/src/hooks/useLanguageFromPath";
import { fetchPlaylist, PulseContentItem } from "plos/src/utils/pulse";
import { useEffect, useState } from "react";
import { NewsList } from "../NewsList";
import { NewsPlaylistProps } from "./types";

const NewsPlaylist = ({
  imgSizes,
  layout,
  limit,
  playlistId,
  variant,
}: NewsPlaylistProps) => {
  const [items, setItems] = useState<PulseContentItem[]>([]);

  const lang = useLanguageFromPath();

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        const playlistData = await fetchPlaylist(playlistId, lang);
        if (cancelled) return;

        const newsItems = (playlistData?.items || [])
          .map((item) => item.response)
          .filter(
            (itemResponse): itemResponse is PulseContentItem =>
              itemResponse != null && typeof itemResponse.id === "number",
          );
        setItems(newsItems);
      } catch (error) {
        if (cancelled) return;
        console.error("Failed to fetch playlist:", error);
        setItems([]);
      }
    };
    fetchData();

    return () => {
      cancelled = true;
    };
  }, [playlistId, lang]);

  if (!items.length) {
    return null;
  }

  return (
    <NewsList
      imgSizes={imgSizes}
      items={limit ? items.slice(0, limit) : items}
      layout={layout}
      variant={variant}
    />
  );
};

export default NewsPlaylist;
